import {
  useDeleteMutation,
  useInsertMutation,
  useUpdateMutation,
} from '@supabase-cache-helpers/postgrest-react-query';

import { supabaseClient } from '@/utils/supabase-client';

export function useAddOrganisationManagedSuppliers() {
  return useInsertMutation(
    supabaseClient.from('organisation_managed_supplier'),
    ['organisation_id', 'supplier_id'],
    '*',
  );
}

export function useEditSupplier() {
  return useUpdateMutation(supabaseClient.from('supplier'), ['id'], '');
}

export function useCreateSupplier() {
  return useInsertMutation(supabaseClient.from('supplier'), ['id']);
}

export function useDeleteOrganisationSupplier() {
  return useDeleteMutation(supabaseClient.from('supplier'), ['id']);
}

export function useDeleteOrganisationManagedSupplier() {
  return useDeleteMutation(
    supabaseClient.from('organisation_managed_supplier'),
    ['organisation_id', 'supplier_id'],
  );
}
